import * as Yup from "yup";

import { MIN_SIGNUP_AGE, latestDobForAge } from "../auth/age";
import { FULL_NAME_PATTERN } from "../auth/validationSchemas";
import { joinName, splitFullName } from "../auth/authMappers";

export const PROFILE_SCHEMA = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(FULL_NAME_PATTERN, "Please enter first and last name"),
  dob: Yup.string()
    .required("Date of birth is required")
    .test(
      "min-age",
      `You must be at least ${MIN_SIGNUP_AGE} years old`,
      (value) => !value || value <= latestDobForAge()
    ),
  gender: Yup.string().required("Gender is required"),
  usage: Yup.string().required("Usage is required"),
  address: Yup.string().trim().required("Address is required"),
});

export const toFormValues = (profile) => ({
  fullName: joinName(profile.firstName, profile.lastName),
  dob: profile.dateOfBirth || "",
  gender: profile.gender || "",
  usage: profile.usage || "",
  address: profile.addressLabel || profile.address?.address1 || "",
  coords: profile.addressCoords || null,
});

const sameCoords = (a, b) =>
  (a?.latitude ?? null) === (b?.latitude ?? null) &&
  (a?.longitude ?? null) === (b?.longitude ?? null);

export const addressChanged = (values, initial) =>
  String(values.address || "").trim() !== String(initial.address || "").trim() ||
  !sameCoords(values.coords, initial.coords);

export const toProfilePatch = (values, address) => {
  const { firstName, lastName } = splitFullName(values.fullName);

  return {
    firstName,
    lastName,
    dateOfBirth: values.dob,
    gender: values.gender,
    usage: values.usage,
    ...(address ? { address } : {}),
  };
};
